'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Phone component used to get the user's phone number
                                                                                                                                                                                                                                                                   * - utilizes Google's libphonenumber for phone formatting (https://github.com/seegno/google-libphonenumber)
                                                                                                                                                                                                                                                                   * - used with account creation and can be a hidden input
                                                                                                                                                                                                                                                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _googleLibphonenumber = require('google-libphonenumber');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var phoneUtil = _googleLibphonenumber.PhoneNumberUtil.getInstance();

var STYLES = {
	logoWrapper: {
		height: '100%',
		position: 'absolute',
		top: 0,
		right: 0
	},

	logo: {
		display: 'inline-block',
		verticalAlign: 'middle'
	},

	errorMessage: {
		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out'
	}
};

var PhoneNumber = _react2.default.createClass({
	displayName: 'PhoneNumber',

	propTypes: {
		type: _react.PropTypes.string.isRequired,
		label: _react.PropTypes.string.isRequired,
		exampleNumber: _react.PropTypes.string.isRequired,
		country: _react.PropTypes.string.isRequired,
		pattern: _react.PropTypes.string,
		maxlength: _react.PropTypes.number,
		required: _react.PropTypes.bool,
		value: _react.PropTypes.string,
		changePhone: _react.PropTypes.func.isRequired,
		errorMessage: _react.PropTypes.string,
		handleFocus: _react.PropTypes.func,
		handleBlur: _react.PropTypes.func
	},

	getDefaultProps: function getDefaultProps() {
		return {
			type: 'tel',
			handleFocus: function handleFocus() {},
			handleBlur: function handleBlur() {}
		};
	},
	getInitialState: function getInitialState() {
		return {
			showIsRequiredError: false
		};
	},


	/**
  * Get the formatted phone number using Google's libphonenumber
  * libphonenumber throws an error if the number provided is only 1 character long
  * @param {String} phone - the phone number
  * @return {String} phone - the formatted phone number
  */
	getFormattedPhoneNumber: function getFormattedPhoneNumber() {
		var phone = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];

		if (phone.length < 2) {
			return phone;
		}
		var phoneNumber = phoneUtil.parse(phone, this.props.country);
		return phoneUtil.format(phoneNumber, _googleLibphonenumber.PhoneNumberFormat.NATIONAL);
	},


	/**
  * Check for a phoneNumber value
  * If the field is required, we should show that this field needs a value
  * @param {String} phoneNumber - the card number
  */
	handleCheckForValue: function handleCheckForValue(phoneNumber) {
		var isRequired = this.props.required;
		this.setState({ showIsRequiredError: isRequired && !phoneNumber });
	},


	/**
  * Handle changing the phone number
  * Remove non-digits from the phone and pass it to Griffin to format it
  * @param {String} phone - the phone number
  * @return {String} phone - the formatted phone number
  */
	handleChangePhone: function handleChangePhone(phone) {
		phone = phone.replace(/\D/g, ''); // remove non-digits for when the griffin formatting kicks in
		this.handleCheckForValue(phone);
		this.props.changePhone(phone);
		return this.getFormattedPhoneNumber(phone);
	},


	/**
  * Call parent's handleFocus
  * @param {String} phoneNumber - the card number
  */
	handleFocus: function handleFocus(phoneNumber) {
		this.props.handleFocus(phoneNumber);
	},


	/**
  * Check for a security code value and call parent's handleBlur
  * @param {String} phoneNumber - the card number
  */
	handleBlur: function handleBlur(phoneNumber) {
		this.handleCheckForValue(phoneNumber);
		this.props.handleBlur(phoneNumber);
	},
	render: function render() {
		var phoneClassNames = (0, _classnames2.default)({
			hidden: this.props.type === 'hidden',
			'vx_form-control': this.props.type !== 'hidden',
			'vx_form-control_complex': this.props.type !== 'hidden'
		});
		var initialValue = this.getFormattedPhoneNumber(this.props.value);
		var errorMessage = this.props.errorMessage;

		var errorStyles = {
			height: 0,
			padding: 0
		};
		if (errorMessage) {
			errorStyles = { height: '100%' };
		}

		return _react2.default.createElement(
			'div',
			{ className: (0, _classnames2.default)({
					'vx_has-error-with-message': errorMessage,
					'vx_has-error': !errorMessage && this.state.showIsRequiredError
				}), style: { margin: '0 0 10px', position: 'relative' } },
			_react2.default.createElement(_reactTextInput2.default, {
				type: this.props.type,
				name: 'phone',
				id: 'phone',
				className: phoneClassNames,
				label: this.props.label,
				helpText: this.props.exampleNumber,
				pattern: this.props.pattern,
				maxlength: this.props.maxlength,
				required: this.props.required,
				value: initialValue,
				handleBlur: this.handleBlur,
				handleFocus: this.handleFocus,
				handleChange: this.handleChangePhone }),
			_react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)({
						'vx_form-control-message': errorMessage
					}), style: _extends({}, STYLES.errorMessage, { errorStyles: errorStyles }) },
				errorMessage
			)
		);
	}
});

exports.default = PhoneNumber;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/react-phone-number/dist/index.js
// module id = 424
// module chunks = 6